import {
  SearchExamineeStatusesInExamEventDocument,
  SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument,
  useGenerateSeatNumberMutation,
} from '@exam-center/graphql';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';
import { useState } from 'react';

import GenerateSeatNumberLoadingModal from '../../components/generate-seat-number-loading-modal/generate-seat-number-loading-modal';

interface ConfirmGenerateSeatNumberModalProps {
  examEventId: string;
  open: boolean;
  onClose: () => void;
}

export default function ConfirmGenerateSeatNumberModal(
  props: Readonly<ConfirmGenerateSeatNumberModalProps>,
) {
  const { open: isOpen, onClose, examEventId } = props;

  const [isLoading, setIsLoading] = useState(false);

  const [generateSeatNumber] = useGenerateSeatNumberMutation({
    variables: {
      generateSeatNumberInput: { examEventId },
    },
    refetchQueries: [
      SearchExamineeStatusesInExamEventDocument,
      SearchExamineeStatusesInExamEventWithDataLoaderSessionExamineeDocument,
    ],
    awaitRefetchQueries: true,
  });

  const { showSnackbar } = useSnackbar();

  const showErrorSnackbar = () => {
    showSnackbar({
      message: 'ไม่สามารถสร้างเลขที่นั่งสอบได้ กรุณาลองใหม่',
      variant: 'error',
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    await generateSeatNumber({
      onCompleted: () => {
        onClose();
      },
      onError: () => {
        onClose();
        showErrorSnackbar();
      },
    });
    setIsLoading(false);
  };

  return (
    <>
      {!isLoading ? (
        <Dialog open={isOpen} onClose={onClose} maxWidth='xs'>
          <DialogTitle onClose={onClose}>ยืนยันการสร้างเลขที่นั่งสอบ?</DialogTitle>
          <DialogContent>
            เมื่อทำการ สร้างเลขที่นั่งสอบ แล้ว <br />
            <strong>จะไม่สามารถสร้างซ้ำหรือแก้ไขเลขที่นั่งได้</strong>
            <br />
            <br />
            กรุณาตรวจสอบข้อมูลผู้เข้าสอบให้ครบถ้วนก่อนดำเนินการต่อ
          </DialogContent>
          <DialogActions>
            <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
              ยกเลิก
            </Button>
            <Button size='large' variant='contained' color='primary' onClick={handleSubmit}>
              ยืนยัน
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <GenerateSeatNumberLoadingModal open={isLoading && isOpen} />
      )}
    </>
  );
}
